export default function handleChange({
  e,
  value,
  name
}) {
  const component = this,
    props = this.props,
    state = this.state;
  let status_messages = state.status_messages;
  delete status_messages[name];
  component.setState({
    [name]: value,
    E_CODE: undefined,
    info: undefined,
    error: undefined,
    warning: undefined,
    status_messages: status_messages
  });
}
